import PeopleAltIcon from '@mui/icons-material/PeopleAlt';

export * from './UserList';
export * from './UserShow';

export const UserIcon = PeopleAltIcon;
